import { useCallback } from "react";
import { useTranslation } from "react-i18next";

const useCaseInsensitiveTranslation = () => {
    const { i18n, t: i18nextT } = useTranslation();

    const t = useCallback(
        (key, options) => {
            if (!key) return "";

            // Exact case-sensitive key lookup
            const translated = i18nextT(key, {
                defaultValue: key,
                ...(options && typeof options === "object" ? options : {}),
            });

            return translated;
        },
        [i18nextT]
    );

    return { t, i18n };
};

export default useCaseInsensitiveTranslation;
